import NumberFormatter from "../../../model/common/NumberFormatter";
import * as React from "react";
import { Input } from "antd";

interface Props {
  value?: string | number;
  name?: any;
  onBlur: any;
  required?: boolean;
  placeholder?: string;
  style?: any;
  onChange?: any;
  qualifierId?: number;
  onFocus?: any;
}

interface State {
  internalValue?: string | number;
  defaultValue?: string | number;
}

const formatter = NumberFormatter();

class NumberField extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      internalValue: this.props.value ? this.props.value : "",
      defaultValue:
        typeof this.props.value === "string" ||
        typeof this.props.value === "number"
          ? formatter.formatEditableValue(this.props.value)
          : undefined
    };
  }

  setInternalValue(text: string | undefined) {
    this.setState({ internalValue: text, defaultValue: undefined });
  }

  render() {
    const {
      onBlur = () => {},
      placeholder,
      required,
      name,
      style,
      onChange,
      qualifierId,
      onFocus
    } = this.props;
    const { internalValue, defaultValue } = this.state;

    return (
      <Input
        style={{ ...style, textAlign: "right" }}
        value={defaultValue || internalValue}
        onChange={(e) => {
          let text = e.currentTarget.value;
          text = formatter.removeNonallowedChars(text);
          this.setInternalValue(text);
          onChange(e);
        }}
        onBlur={(e) => {
          const formattedValue = internalValue
            ? NumberFormatter().formatEditableValue(internalValue)
            : undefined;
          this.setInternalValue(formattedValue);

          onBlur(
            name,
            null,
            null,
            null,
            formattedValue
              ? Number(formatter.formatStandardNumber(formattedValue))
              : undefined,
            null,
            null,
            null,
            qualifierId,
            null
          );
        }}
        placeholder={placeholder}
        required={required}
        onFocus={onFocus}
        title={""}
      />
    );
  }
}

export default NumberField;
